export const authConstant = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGOUT_REQUEST: "LOGOUT_REQUEST",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_FAILURE: "LOGOUT_FAILURE",

  TOKEN_VALID_SUCCESS: "TOKEN_VALID_SUCCESS",
  TOKEN_VALID_FAIL: "TOKEN_VALID_FAIL",

  GET_ADMINS_SUCCESS: "GET_ADMINS_SUCCESS",
  GET_UNSEEN_CHAT: "GET_UNSEEN_CHAT",
};

export const brandConstant = {
  BRAND_REQUEST: "BRAND_REQUEST",
  BRAND_CREATE_SUCCESS: "BRAND_CREATE_SUCCESS",
  BRAND_CREATE_FAIL: "BRAND_CREATE_FAIL",
  GET_BRAND_SUCCESS: "GET_BRAND_SUCCESS",
  GET_BRAND_FAIL: "GET_BRAND_FAIL",
  GET_DELETED_BRAND_SUCCESS: "GET_DELETED_BRAND_SUCCESS",
  GET_DELETED_BRAND_FAIL: "GET_DELETED_BRAND_FAIL",
};
export const subcategoryConstant = {
  SUBCATEGORY_REQUEST: "SUBCATEGORY_REQUEST",
  SUBCATEGORY_CREATE_SUCCESS: "SUBCATEGORY_CREATE_SUCCESS",
  SUBCATEGORY_CREATE_FAIL: "SUBCATEGORY_CREATE_FAIL",
  GET_SUBCATEGORY_SUCCESS: "GET_SUBCATEGORY_SUCCESS",
  GET_SUBCATEGORY_FAIL: "GET_SUBCATEGORY_FAIL",
  GET_DELETED_SUBCATEGORY_SUCCESS: "GET_DELETED_SUBCATEGORY_SUCCESS",
  GET_DELETED_SUBCATEGORY_FAIL: "GET_DELETED_SUBCATEGORY_FAIL",
};

export const productConstant = {
  PRODUCT_REQUEST: "PRODUCT_REQUEST",
  PRODUCT_CREATE_SUCCESS: "PRODUCT_CREATE_SUCCESS",
  PRODUCT_CREATE_FAIL: "PRODUCT_CREATE_FAIL",
  GET_PRODUCT_SUCCESS: "GET_PRODUCT_SUCCESS",
  GET_PRODUCT_FAIL: "GET_PRODUCT_FAIL",
  GET_DELETED_PRODUCT_SUCCESS: "GET_DELETED_PRODUCT_SUCCESS",
  GET_DELETED_PRODUCT_FAIL: "GET_DELETED_PRODUCT_FAIL",
};
export const taxConstant = {
  TAX_REQUEST: "TAX_REQUEST",
  TAX_CREATE_SUCCESS: "TAX_CREATE_SUCCESS",
  TAX_CREATE_FAIL: "TAX_CREATE_FAIL",
  GET_TAX_SUCCESS: "GET_TAX_SUCCESS",
  GET_TAX_FAIL: "GET_TAX_FAIL",
  GET_ARCHIVED_TAX_SUCCESS: "GET_ARCHIVED_TAX_SUCCESS",
  GET_ARCHIVED_TAX_FAIL: "GET_ARCHIVED_TAX_FAIL",
};
export const cashierConstant = {
  CASHIER_REQUEST: "CASHIER_REQUEST",
  CASHIER_CREATE_SUCCESS: "CASHIER_CREATE_SUCCESS",
  CASHIER_CREATE_FAIL: "CASHIER_CREATE_FAIL",
  GET_CASHIER_SUCCESS: "GET_CASHIER_SUCCESS",
  GET_CASHIER_FAIL: "GET_CASHIER_FAIL",
  GET_CASHIER_BANNED_PENDING_SUCCESS: "GET_CASHIER_BANNED_PENDING_SUCCESS",
  GET_CASHIER_BANNED_PENDING_FAIL: "GET_CASHIER_BANNED_PENDING_FAIL",
  GET_ARCHIVED_CASHIER_SUCCESS: "GET_ARCHIVED_CASHIER_SUCCESS",
  GET_ARCHIVED_CASHIER_FAIL: "GET_ARCHIVED_CASHIER_FAIL",
};
export const customerConstant = {
  CUSTOMER_REQUEST: "CUSTOMER_REQUEST",
  CUSTOMER_CREATE_SUCCESS: "CUSTOMER_CREATE_SUCCESS",
  CUSTOMER_CREATE_FAIL: "CUSTOMER_CREATE_FAIL",
  GET_CUSTOMER_SUCCESS: "GET_CUSTOMER_SUCCESS",
  GET_CUSTOMER_FAIL: "GET_CUSTOMER_FAIL",
  GET_ARCHIVED_CUSTOMER_SUCCESS: "GET_ARCHIVED_CUSTOMER_SUCCESS",
  GET_ARCHIVED_CUSTOMER_FAIL: "GET_ARCHIVED_CUSTOMER_FAIL",
  GET_CUSTOMER_ALL_SUCCESS: "GET_CUSTOMER_ALL_SUCCESS",
  GET_CUSTOMER_ALL_FAIL: "GET_CUSTOMER_ALL_FAIL",
};
export const socketConstant = {
  LOGIN_SOCKET_CONNECTION: "LOGIN_SOCKET_CONNECTION",
  DISCONNECT_SOCKET_CONNECTION: "DISCONNECT_SOCKET_CONNECTION",
};
export const depositConstant = {
  CUSTOMER_DEPOSIT_REQUEST: "CUSTOMER_DEPOSIT_REQUEST",

  GET_DEPOSIT_SUCCESS: "GET_DEPOSIT_SUCCESS",
  GET_DEPOSIT_FAIL: "GET_DEPOSIT_FAIL",
};
export const salesConstant = {
  SALES_REQUEST: "SALES_REQUEST",
  GET_SALES_SUCCESS: "GET_SALES_SUCCESS",
  GET_SALES_FAIL: "GET_SALES_FAIL",
};
